module.exports = __webpack_public_path__ + "img/title.cb48011b.gif";